import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Button,
  Heading,
  OrSeparator,
  CreateButton as DefaultCreateButton,
  HighlightedInput,
  Label,
  InputGroup,
  ItemListItem,
  ItemListHeading,
  ItemListSubheading,
  ItemListSubheadingButton,
  ItemListActionContainer,
} from 'prospect-path-components';

import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { history } from '../store';
import joinTeam from '../actions/JoinTeam';
import createTeam from '../actions/CreateTeam';

const Container = styled.div`
    max-width: 25rem;
    margin-left: auto;
    margin-right: auto;
`;

const ImageContainer = styled.div`
    padding: 1.8rem 0;
`;

const ContainerBody = styled.div`
    padding-top: 30%;
`;

const CreateButton = styled(DefaultCreateButton)`
  background-color: white;
  padding-top: 1.5rem;
`;

class Team extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createTeamExpanded: false,
      newTeamName: '',
      selectedTeamId: null,
    };

    this.toggleCreateTeamExpanded = this.toggleCreateTeamExpanded.bind(this);
    this.changeNewTeamName = this.changeNewTeamName.bind(this);
    this.handleSelectProducts = this.handleSelectProducts.bind(this);
    this.handleJoinButton = this.handleJoinButton.bind(this);
    this.selectProductsEnabled = this.selectProductsEnabled.bind(this);
  }
  componentDidMount() {
    document.title = 'Join a Team | Prospect Path';
  }
  handleSelectProducts() {
    // If create team is expanded create a new team
    if (this.state.createTeamExpanded && this.state.newTeamName !== '') {
      this.props.createTeam(this.state.newTeamName);

      return;
    }

    if (this.props.selectedTeamId !== null) {
      this.props.joinTeam(this.state.selectedTeamId);
    }
  }
  handleJoinButton(teamId) {
    // If the team is currently selected unselect it
    if (this.state.selectedTeamId === teamId) {
      this.setState({
        selectedTeamId: null,
      });

      return;
    }

    // Otherwise select the team and collapse the create team area
    this.setState({
      selectedTeamId: teamId,
      createTeamExpanded: false,
    });
  }
  toggleCreateTeamExpanded() {
    if (!this.state.createTeamExpanded) {
      this.setState({
        selectedTeamId: null,
      });
    }

    this.setState({
      createTeamExpanded: !this.state.createTeamExpanded,
    });
  }
  changeNewTeamName(event) {
    this.setState({
      newTeamName: event.target.value,
    });
  }
  selectProductsEnabled() {
    // If a team is selected then the button is enabled
    if (this.state.selectedTeamId !== null) {
      return true;
    }

    // If create new team is expanded and a name has been entered it is enabled
    return this.state.createTeamExpanded && this.state.newTeamName !== '';
  }
  render() {
    // Don't display anything while the page loads
    if (this.props.user.loading || this.props.loadingTeams || this.props.vendorDomain.loading) {
      return '';
    }
    if (this.props.user.id === null) {
      return <Redirect to="/signup/product" />;
    }
    if (this.props.userTeams.length > 0) {
      window.location = `/signup/product/teams/${this.props.userTeams[0]}`;
    }

    if (
      !this.props.loadingTeams &&
      this.props.teams.length === 0 &&
      !this.props.vendorDomain.loading
    ) {
      this.props.createTeam(this.props.vendorDomain.data.domain);

      return '';
    }

    const teams = this.props.teams.map(team => (
      <ItemListItem key={team.id}>
        <div>
          <ItemListHeading>
            {team.name}
          </ItemListHeading>
          <ItemListSubheading>
            <ItemListSubheadingButton onClick={() => history.push(`/signup/teams/${team.id}`)}>
              Manages {team.products.length < 1 ? 'no' : team.products.length} products
            </ItemListSubheadingButton>
          </ItemListSubheading>
        </div>
        <ItemListActionContainer>
          <Button color={team.id === this.state.selectedTeamId ? 'primary' : ''} onClick={() => this.handleJoinButton(team.id)}>Join</Button>
        </ItemListActionContainer>
      </ItemListItem>
    ));

    let createTeam = '';
    if (this.state.createTeamExpanded) {
      createTeam = (
        <InputGroup>
          <Label>
            New team name
          </Label>
          <HighlightedInput
            value={this.state.newTeamName}
            onChange={this.changeNewTeamName}
          />
        </InputGroup>
      );
    }

    return (
      <div>
        <Container>
          <ImageContainer>
            <img src="/images/logo.svg" />
          </ImageContainer>

          <ContainerBody>
            <Heading>Join a Team</Heading>

            <div>
              {teams}
            </div>

            <OrSeparator />

            <CreateButton onClick={this.toggleCreateTeamExpanded}>Create New Team</CreateButton>

            {createTeam}

            <Button
              style={{ marginTop: '2rem' }}
              block
              color="primary"
              onClick={this.handleSelectProducts}
              disabled={!this.selectProductsEnabled() ? 'disabled' : ''}
            >Select Products</Button>
          </ContainerBody>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  teams: state.teams.all,
  userTeams: state.teams.userTeams,
  loadingTeams: state.teams.loadingTeams,
  vendorDomain: state.productManagement.vendorDomain,
});

const mapDispatchToProps = dispatch => ({
  joinTeam: teamId => dispatch(joinTeam(teamId)),
  createTeam: name => dispatch(createTeam(name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Team);
